import { Path } from "../../../app.config";
import { User } from '../../../model/user/user.model';
import { CorporateEntity } from "../../../model/user/corporateEntity.model";
import { Constant } from '../../../model/common/constant';
//const ACTIVECOMPANYSTORAGEKEY: string = "ACTIVECOMPANY";
const LOGGEDINUSERSTORAGEKEY: string = "LOGGEDINUSER";


export class AuthenticationService {


    private user: User;
    private activeCompany: CorporateEntity;    
    public appDate: string = "";
    

    public static $inject: Array<string> = ['$window'];
    constructor(private $window: ng.IWindowService) {
        
    }
    getAppDateFormat(): string {
        if (this.user.Region === "EMEA") {
            this.appDate=Constant.DateTimeFormat.EMEADATE
        }
        else {
            this.appDate=Constant.DateTimeFormat.LOCAL
        }
        return this.appDate;
    }   

    logout() {
        if (this.$window.sessionStorage) this.$window.sessionStorage.clear();
        if (this.$window.localStorage) this.$window.localStorage.clear();
        delete this.user;        
        //TODO: Inject $location and use for navigation.
        this.$window.location.href = Path.Provider.ApplicationPath + "/Error/Error";
    }

    setLoggedInUserInfo(user: User) {

        this.user = user;
        this.$window.localStorage.setItem(LOGGEDINUSERSTORAGEKEY, JSON.stringify(this.user));
    }

    getLoggedInUserInfo(): User {
        if (this.user) return this.user;
        else {
            let user = localStorage.getItem(LOGGEDINUSERSTORAGEKEY);
            if (user) return JSON.parse(user);
        }
    }

    navigateToLoginPage() {
        if (this.$window.sessionStorage) this.$window.sessionStorage.clear();
        if (this.$window.localStorage) this.$window.localStorage.clear();        
        delete this.user;
        this.$window.location.href = Path.Provider.ApplicationPath + "Login/UMLogin/LogOff";
    }

    isSelfUserNameModified(usrObj: User): boolean {
        //var scope = this;
        //var checkUserName = usrObj.LoginName.trim().toLocaleLowerCase() != this.user.LoginName.trim().toLocaleLowerCase()
        if (usrObj.Id === this.user.Id) {
            //if (checkUserName) {
            //    scope.navigateToLoginPage();
            //}
            return usrObj.LoginName.trim().toLocaleLowerCase() != this.user.LoginName.trim().toLocaleLowerCase();
        }
        return false;
    }
}